import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { LucideIcon, Table2 } from 'lucide-react-native';
import { memo } from 'react';
import { View } from 'react-native';
import { BiViewMode } from '../functions/biViewMode';
import { ViewSegment } from './ViewSegment';

/**
 * One tap between a chart and its result table. View state only: it needs
 * no edit permission and saves nothing.
 */
export const BiViewToggle = memo(
  ({
    chartIcon,
    value,
    onChange,
  }: {
    /** The chart's own icon, for the chart side. */
    chartIcon: LucideIcon;
    value: BiViewMode;
    onChange: (next: BiViewMode) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        accessibilityRole="radiogroup"
        style={{
          flexDirection: 'row',
          padding: rpx(2),
          gap: rpx(2),
          borderRadius: rpx(8),
          backgroundColor: aiColors.muted,
        }}
      >
        <ViewSegment
          icon={chartIcon}
          label="显示图表"
          selected={value === BiViewMode.Chart}
          onPress={() => onChange(BiViewMode.Chart)}
        />
        <ViewSegment
          icon={Table2}
          label="显示数据表"
          selected={value === BiViewMode.Table}
          onPress={() => onChange(BiViewMode.Table)}
        />
      </View>
    );
  },
);
